<template>
  <section>
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('SUBJECT', 2) }) | formatTitle"></vue-headful>
    <subject-list></subject-list>

    <article class="subjects__route">
      <router-view></router-view>
    </article>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
article.subjects__route {
  height: 100%;
}
</style>

<script>
// @flow
import SubjectList from './SubjectList'

export default {
  name: 'subjects',
  components: { SubjectList }
}
</script>
